import CurrencyFormConfig from "./form";
import { CurrencyApi, CurrencyDataType } from "@/api/CurrencyApi";
import { CurrencyFormData } from "@/formTypes/CurrencyFormDataType";
import GenericForm from "../GenericForm";

type CurrencyFormProps = {
  id?: string;
  formId: string,
  saveRedirectUrl: string
}

const CurrencyForm = (props: CurrencyFormProps) => {

  return (
    <GenericForm<CurrencyFormData, CurrencyDataType>
      id={props.id}
      formId={props.formId}
      saveRedirectUrl={props.saveRedirectUrl}
      formConfig={CurrencyFormConfig}
      getById={(...arg) => CurrencyApi.get(...arg)}
      createFn={(...arg) => CurrencyApi.create(...arg)}
      updateFn={(...arg) => CurrencyApi.update(...arg)}
      successMessage="La moneda ha sido almacenada correctamente"
      errorMessage="No fue posible almacenar la información de la moneda"
    />
  )
}

export default CurrencyForm;